















// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VueMask from 'v-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { defineComponent } from '@vue/composition-api';
import Vue from 'vue';
Vue.use(VueMask);

/**
 * Reusable amount component.
 */
export default defineComponent({
	props: {
		name: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
		},
		unit: {
			type: String,
			required: false,
		},
		onInput: {
			type: Function,
			required: false,
		},
		onBlur: {
			type: Function,
			required: false,
		},
		allowDecimals: {
			type: Boolean,
			required: false,
			default: true,
		},
		allowNegative: {
			type: Boolean,
			required: false,
			default: false,
		},
		includeThousandsSeparator: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	setup(props) {
		const currencyMask = createNumberMask({
			prefix: '',
			allowDecimal: props.allowDecimals,
			allowNegative: props.allowNegative,
			decimalSymbol: ',',
			includeThousandsSeparator: props.includeThousandsSeparator,
			thousandsSeparatorSymbol: '.',
		});
		return { currencyMask, myInputModel: props.value };
	},
});
